import { getSharedPremiumResource, PremiumSharedResource } from '@wix/premium-fed-sdk';
export const QueryUtils = {
  findQuery(ApiClient, queryName) {
    const premiumResource = getSharedPremiumResource(PremiumSharedResource.QueryClientInstance);
    const queries = premiumResource == null ? void 0 : premiumResource.getQueryCache().getAll();
    const matchingQuery = queries == null ? void 0 : queries.find(query => {
      var _ApiClient$getMethodF;
      return ((_ApiClient$getMethodF = ApiClient.getMethodFromQuery(query)) == null ? void 0 : _ApiClient$getMethodF.name) === queryName;
    });
    return matchingQuery;
  },
  getQueryFromCache(ApiClient, queryName) {
    const query = QueryUtils.findQuery(ApiClient, queryName);
    return query == null ? void 0 : query.state.data;
  },
  setQueryData(ApiClient, queryName, data) {
    const query = QueryUtils.findQuery(ApiClient, queryName);
    query == null || query.setData(data);
  }
};
//# sourceMappingURL=query.utils.js.map